import mixins from 'vue-typed-mixins';

import UserStamp from '@/user/components/userStamp/UserStamp.vue';

import UnitSelectMixin from '@/user/mixins/UnitSelectMixin';
import WindowAdjustMixin from '@/user/mixins/WindowAdjustMixin';

import { USER_STORAGE_KEY } from '@/classes/common/Constants';
import SectionData from '@/classes/data/SectionData';
import StorageUtility from '@/classes/common/StorageUtility';




export default mixins(UnitSelectMixin, WindowAdjustMixin).extend({

  name: 'UnitSelectCalc',

  components: {
    UserStamp,
  },

  data(): {
    tabs: SectionData[][];
    selectTabIndex: number;
  } {
    return {
      tabs: [],
      selectTabIndex: 0,
    };
  },

  async created(): Promise<void> {
    // 進度読み込み
    await this.loadProgressesState(this.courseId);

    this.$_initializeTabs();
  },

  methods: {
    sectionTitleHtml(sectionNo: number, sectionName: string): string {
      return `${sectionNo}. ${sectionName.replace(/\\n/g, '<br />')}`;
    },
    // UnitSelectMixin を上書き
    toStudy(sectionNo: number, unitNo: number): void {
      // 選択した単元Noを保持
      StorageUtility.setSessionData<number>(USER_STORAGE_KEY.STUDY_SECTION_NO, sectionNo);

      this.$router.push({
        name: this.routes.Study.name,
        params: this.$route.params,
        query: {
          sectionNo: String(sectionNo),
          unitNo:    String(unitNo),
        }
      });
    },
    // WindowAdjustMixin を上書き
    onChangeWindowSizeHandler(): void {
      this.$_initializeTabs();
    },
    $_initializeTabs(): void {
      const maxLinesPerTab  = this.isPortrait ? 12 : 7;
      const maxUnitsPerLine = this.isPortrait ? 5 : 10;

      let lineCountInTab = 0;
      let sectionsInTab: SectionData[] = [];
      this.tabs = [sectionsInTab];
      this.selectTabIndex = 0;
      this.sections.forEach(s => {
        const lineCount = Math.ceil(s.unitCount / maxUnitsPerLine);

        // タブ当たりの最大行数を超える場合
        if (maxLinesPerTab < lineCountInTab + lineCount) {
          sectionsInTab  = [s];
          lineCountInTab = lineCount;
          this.tabs.push(sectionsInTab);
          return;
        }

        sectionsInTab.push(s);
        lineCountInTab += lineCount;
      });

      // セッションストレージに学習単元Noがある場合は該当のタブを選択する
      const studySectionNo = StorageUtility.getSessionData<number>(USER_STORAGE_KEY.STUDY_SECTION_NO);
      if (studySectionNo !== null) {
        this.selectTabIndex = this.tabs.findIndex(tab => tab.some(section => section.sectionNo === studySectionNo));
      }
    },
  },

});
